import React, { Component } from 'react';
import { WatermarkGenerate } from '@tencent/docs-scenario-components-watermark-generate';
import { observer } from 'mobx-react';
import { IWatermarkManager } from '@src/slide/application/service/watermark-manager/core/interface';

interface WatermarkMaskProps {
    isUseStaticData?: boolean;
    watermarkManager: IWatermarkManager;
}


@observer
class WatermarkMask extends Component<WatermarkMaskProps> {
    private watermarkManager: IWatermarkManager;
    private playerSVGInfo: any;
    public constructor(props: WatermarkMaskProps, context: any) {
        super(props, context);
        this.playerSVGInfo = null;
    }

    public async componentDidMount() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        this.watermarkManager = this.props.watermarkManager;
        if (typeof (this.props.isUseStaticData) !== 'undefined') {
            this.watermarkManager.getPlayerSVGInfo()
                .then((svgInfo) => {
                    this.playerSVGInfo = svgInfo;
                    self.forceUpdate();
                });
        } else {
            // 生成水印数据
            await this.watermarkManager.generateWatermarkSVG();
        }
        this.forceUpdate();
    }

    public render() {
        // 移动端暂时先用旧的水印组件，因为iOS上会OOM
        const Watermark = WatermarkGenerate;
        // 用于不自动刷新更新的静态水印情况，适配演示场景
        if (typeof (this.props.isUseStaticData) !== 'undefined') {
            if (!this.playerSVGInfo) {
                return null;
            }
            return (
                <Watermark
                    key='player-tdocs-watermark-generate'
                    base64Data={this.playerSVGInfo.base64Data}
                    base64NickData={this.playerSVGInfo.base64NickData}
                    canvasHeight={this.playerSVGInfo.canvasHeight}
                    lineHeight={this.playerSVGInfo.lineHeight}
                />
            );
        }
        const watermarkSVGInfo = this.watermarkManager?.watermarkSVGInfo;
        if (typeof(watermarkSVGInfo) !== 'undefined' && watermarkSVGInfo !== null) {
            return (
                <Watermark
                    key='tdocs-watermark-generate'
                    base64Data={watermarkSVGInfo.base64Data}
                    base64NickData={watermarkSVGInfo.base64NickData}
                    canvasHeight={watermarkSVGInfo.canvasHeight}
                    lineHeight={watermarkSVGInfo.lineHeight}
                />
            );
        }
        return null;
    }
}

export default WatermarkMask;
